var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobconfigAdditionalNone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_73856_76379)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 30C60 13.431 46.569 -5.87087e-07 30 -1.31134e-06C13.431 -2.0356e-06 -5.87087e-07 13.431 -1.31134e-06 30C-2.0356e-06 46.569 13.4297 60 30 60C46.569 59.9988 60 46.569 60 30ZM30 4.52313C44.0693 4.52313 55.4756 15.9294 55.4756 29.9988C55.4756 33.7963 54.6428 37.4006 53.153 40.6383L8.47775 16.367C12.9946 9.24947 20.945 4.52312 30 4.52313ZM4.52562 30C4.52562 26.938 5.0667 24.0032 6.05535 21.2854L50.3379 45.341C45.6888 51.4973 38.3094 55.4744 30 55.4744C15.9307 55.4744 4.52562 44.0693 4.52562 30Z",
    fill: "#F38D33"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_73856_76379"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "translate(60) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobconfigAdditionalNone);
export default __webpack_public_path__ + "static/media/jobconfig-additional-none.09bcc9bfec0c1fa6eb2c230f77dba41a.svg";
export { ForwardRef as ReactComponent };